<div _ngcontent-c0="" class="app-content ui basic segment container">
  <div _ngcontent-c3="" class="ui basic segment wrapper">
    <div class="ui middle aligned">
      <form [formGroup]="userForm" (ngSubmit)="save()" _ngcontent-c3=""
        class="ui form" novalidate="" autocomplete="off">

        <h2 _ngcontent-c3="" class="ui image header center aligned">
          <div _ngcontent-c3="" class="content">
            Update Details
          </div>
        </h2>
        <div class="ui divider"></div>

        <div class="ui red message" *ngIf="(errorMsg != 'default')">
          {{ errorMsg }}
        </div>

        <fieldset>
          <div class="two fields">
            <div class="required field">
              <label>First Name</label>
              <input formControlName="firstname" type="text" value="" />
            </div>
            <div class="required field">
              <label>Last Name</label>
              <input formControlName="surname" type="text" value="" />
            </div>
          </div>

          <div class="two fields">
            <div class="required field">
              <label>Middle Name</label>
              <input formControlName="otherName" type="text" value="" />
            </div>
            <div class="required field">
              <label>Phone Number</label>
              <input formControlName="phoneNumber" type="text" value="" />
            </div>
          </div>

          <div class="two fields">
            <div class="required field" formGroupName="nationalityFk">
              <label>Nationality</label>
              <select formControlName="id">
                <option value="">Select Nationality</option>
                <option *ngFor="let row of (nationalityList | keyvalue )" _ngcontent-c36="" value="{{ row?.key }}">
                  {{ row?.value | uppercase }}
                </option>
              </select>
            </div>
            <div class="required field">
              <label>Occupation/Description</label>
              <input formControlName="occupation" name="occupation" placeholder="Occupation/Description" type="text" class="">
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>Address</legend>
          <div class="ui form ">
            <div class="three fields">
              <div class="required field" formGroupName="countryFk">
                <label>Country</label>
                <select formControlName="id" id="id" class="ui " (change)="getStates($event?.target['value'])">
                  <option >-Select Country-
                  </option>
                  <option *ngFor="let country of countryList | keyvalue" value="{{ country?.key }}">
                    {{ country?.value | uppercase }}</option>
                </select>
              </div>
              <div class="field required">
                <label>State</label>
                <select formControlName="state" id="state" class="ui " (change)="getLgas($event?.target['value'])">
                  <option >-Select State-</option>
                  <option *ngFor="let row of stateList | keyvalue" value="{{ row?.key }}">
                    {{ row?.value | uppercase }}
                  </option>
                </select>
              </div>
              <div class="field required">
                <label>LGA</label>
                <select formControlName="lga" id="lga" class="ui ">
                  <option >-Select LGA-</option>
                  <option *ngFor="let row of lgaList | keyvalue" value="{{ row?.key }}">
                    {{ row?.value | uppercase }}
                  </option>
                </select>
              </div>
            </div>
            <div class="three fields">
              <div class="required field">
                <label>Post Code</label>
                <input formControlName="postcode" name="postcode" placeholder="Post Code" class="">
              </div>
              <div class="required field">
                <label>City/Town/Village</label>
                <input formControlName="city" name="city" placeholder="City" class="">
              </div>
              <div class="required field">
                <label>House Number/Building Name</label>
                <input formControlName="streetNumber" name="streetNumber" placeholder="House Number/Building Name" class="">
              </div>
            </div>
            <div class="required field">
              <label>Street Name</label>
              <input formControlName="address" placeholder="Address" class="">
            </div>
          </div>
        </fieldset>

        <fieldset class="mt-3">
          <legend>Means of Identification</legend>
          <div class="two fields ">
            <div class="field required">
              <label>Type</label>
              <select (change)="controlTypeOfIdValidators($event?.target['value'])" formControlName="identityType">
                <option value="">-Select Type-</option>
                <option value="Age Declaration">Age Declaration</option>
                <option value="Birth Certificate">Birth Certificate</option>
                <option value="Driver's License">Driver's License</option>
                <option value="International Passport">International Passport</option>
                <option value="National ID Card">National ID Card</option>
                <option value="Permanent Voters' Card">Permanent Voters' Card</option>
              </select>
            </div>
            <div class="field required">
              <label>{{formOfIdLabel}}</label>
              <input formControlName="nin" name="nin" placeholder="Identity Number" class="">
              <div
                *ngIf="(userFormControl.nin.touched || userFormControl.nin.dirty || submitted) && userFormControl.nin.errors">
                <div *ngIf="userFormControl.nin.errors.minlength"
                  class="ui red top pointing prompt label transition visible">
                  Invalid Entry: Must be at least {{userFormControl.nin.errors.minlength.requiredLength}} digit.
                  You currently have {{userFormControl.nin.errors.minlength.actualLength}}
                </div>
                <div *ngIf="userFormControl.nin.errors.maxlength"
                  class="ui red top pointing prompt label transition visible">
                  Invalid Entry: Can not be more than {{userFormControl.nin.errors.maxlength.requiredLength}}
                  digit.
                  You currently have {{userFormControl.nin.errors.maxlength.actualLength}}
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <div class="ui divider"></div>

        <h3 class="mt-5">UPDATE DOCUMENT(S)</h3>
        <ngb-alert [type]="'warning'" [dismissible]="false">
          Maximum of 3mb Size per document type
        </ngb-alert>
        <table class="ui celled table">
          <thead>
            <tr>
              <th>Document</th>
              <th>File Format</th>
              <th>Is Required</th>
              <th>Upload</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of documentService.uploadFiles; let i = index;">
              <td>
                <i class="file pdf outline icon green"></i> <strong>{{ row?.docName }}</strong>
              </td>
              <td>{{row.fileType | uppercase}}</td>
              <td>
                <i class=""></i> <strong>{{ row?.required ? "YES" : "NO" }}</strong>
              </td>
              <td>
                <input type="hidden" id="docName{{i}}" value="{{row.docName}} " required>
                <div style="display: none;">
                  <input type="file" id="mRequest{{i}}" accept="{{row.fileExtension}}"
                    (change)="documentService.fileProgress($event, row, 'uploadStatus'+i)" required>
                </div>

                <a class="ui right labeled icon button primary floated" (click)="documentService.fileUploadHandler($event, 'mRequest'+i)">
                  <i class="upload icon"></i> <span>Upload</span>
                </a>
              </td>
              <td data-label="Status" id="uploadStatus{{i}}">
                <div class="mb-3">

                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="column">
          <a (click)="goBack()" class="ui labeled icon button primary">
            <i class="left chevron icon"></i>
            Back
          </a>

          <button [disabled]="userForm.invalid" [ngClass]="loading ? 'disabled' : ''" type="submit"
            class="ui right floated primary button " tabindex="0">
            <i style="font-size:medium;" class="fa fa-spinner fa-spin" *ngIf="loading"></i>
            Save &amp; Continue
            <i class="right chevron icon"></i>
          </button>
        </div>
      </form>
    </div>

  </div>
</div>
